module.exports = __webpack_public_path__ + "static/img/5.92ff246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/5.jpg
// module id = p6zS
// module chunks = 1